import React from "react";
import { useLocation } from "react-router-dom";
import NavBar from "./Navbar/Navbar.jsx";
import MainContent from "./MainContent";
import { useSelector } from "react-redux";
import AlertsGrid from "./General/Alert/AlertsGrid.jsx";

function PageStructureWithRouter() {
  const location = useLocation();
  const singleBodyPages = [
    "/login",
    "/register",
    "/landing",
    "/verifyEmail",
    "/docs/support",
    "/settings/resetPassword",
  ];
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  return (
    <>
      {!singleBodyPages.includes(location.pathname) && isLoggedIn && <NavBar />}
      <MainContent />
      <AlertsGrid />
    </>
  );
}

export default PageStructureWithRouter;
